import React from 'react';
import { useTheme } from 'styled-components';
import * as S from './ShopsList.styles';
import { ShopsListItem } from '@/components/Shops/ShopsListItem';
import { PhonesBottomSheet } from '@/components/PhonesBottomSheet/PhonesBottomSheet';
import { sleep } from '@/utils/helpers';
import { useOpenContacts } from '@/hooks/useOpenContacts';
import { useResponsive } from '@/hooks/useResponsive';
import type { FavoriteShops } from '@/api/types/shop.types';
import { useShopsPhonesController } from '@/components/Shops/hooks/useShopsPhonesController';

interface ShopsListProps {
  shops: FavoriteShops[];
  loading?: boolean;
}

export const ShopsList: React.FC<ShopsListProps> = ({ shops, loading }) => {
  const { isDesktop } = useResponsive();
  const theme = useTheme();

  const {
    isContactsOpen,
    toggleContacts,
    getPhoneNumbers: getPhoneNumbersOriginal,
    phoneNumbers,
  } = useOpenContacts({
    shouldOpenBottomSheet: !isDesktop,
    shouldStartCall: !isDesktop,
  });

  const { getPresentationForShop } = useShopsPhonesController({
    isDesktop,
    phoneNumbers,
    getPhoneNumbersOriginal,
  });

  async function closeContacts() {
    toggleContacts(false);
    await sleep(500);
  }

  return (
    <>
      <S.Box $loading={loading && shops.length === 0}>
        {loading && shops.length === 0
          ? Array.from({ length: 12 }).map((_, index) => (
              <S.SkeletonCard key={index} />
            ))
          : shops.map(shop => {
              const presentation = getPresentationForShop(shop.id);
              return (
                <ShopsListItem
                  key={shop.id}
                  shop={shop}
                  singlePhone={presentation.singlePhone}
                  popupPhones={presentation.popupPhones}
                  onShowNumberClick={e =>
                    presentation.onShowNumberClick(e, shop.id)
                  }
                  onClosePopup={presentation.onClosePopup}
                />
              );
            })}
      </S.Box>
      {!isDesktop && (
        <PhonesBottomSheet
          isOpen={isContactsOpen}
          close={closeContacts}
          phones={phoneNumbers}
          color={theme.palette.system.green}
        />
      )}
    </>
  );
};
